
import Basic from '@/components/widgets/Basic.vue';
import ProductData from '@/interfaces/ProductData';
import NonCommodityProductFacade from '@/models/NonCommodityProductFacade';
import ThgServiceElliDefault from '@/models/thg/ThgServiceElliDefault';

export default abstract class NonCommodityBase extends Basic {
  public extendedData: Record<any, any> = {};

  public get thgConfig(): ThgServiceElliDefault {
    return ThgServiceElliDefault.instance;
  }

  public get nonCommodityProduct(): NonCommodityProductFacade {
    return NonCommodityProductFacade.withData(this.productData);
  }

  protected get productData(): ProductData {
    return this.store.state.nonCommodityProductData;
  }

  protected linkThgConfigExtendedData(): void {
    // Keep this, we need the reference.
    this.extendedData = this.thgConfig.extendedData;
  }
}
